import { render, staticRenderFns } from "./MiniShopContainer.vue?vue&type=template&id=aa915722&lang=pug"
import script from "./MiniShopContainer.vue?vue&type=script&lang=js"
export * from "./MiniShopContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports